module.exports = __webpack_public_path__ + "0718d0f8e432d106eefb3a0fc83f828c.png";